<script setup>
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import http from './http.js';

const emit = defineEmits(['back'])
const props = defineProps(['cancelPossible'])

const basket = ref({
    items:[],
    voucher:{}
})

const customer = ref({
    first_name:'',
    middle_name:'',
    last_name:'',
    phone:'',
    subscribed:true,
    email:''
})

const extras = ref('')
const errors = ref(null)
const step  = ref(1)
const loading = ref(false)

onMounted(async ()=>{
    let r = await http.get('cart');

    let cus = JSON.parse(sessionStorage.getItem('customer'));
    if(cus){
        customer.value = cus
        if(cus.id){
            step.value = 2
        }
    }

    if(r.data){
        basket.value = r.data;
        basket.value.items = Object.values(basket.value.items ?? [])
        if(r.data.voucher && r.data.voucher.email){
            customer.value.email = r.data.voucher.email
        }
    }

})


const stepThree = async ()=>{
    loading.value = true
    http.post('/customer', customer.value)
    .then((r)=>{
        sessionStorage.setItem('customer', JSON.stringify(r.data))
        customer.value = r.data
        step.value = 2
    })
    .catch((e)=>{
        console.log(e)
        errors.value = e.response.data.errors
    }).finally(()=>{
        loading.value = false
    })
}

const checkout = async ()=>{
    loading.value = true
    
    let data = await http.post('/checkout',{
        customer_id: customer.value.id,
        extras: extras.value,
    }).catch((e)=>{
        loading.value=false;
    })

    //console.log(data)
    if(!data.data.checkout_url){
        alert('Er is iets mis gegaan! Probeer het opnieuw of stuur een email naar info@toneelgroepfacet.nl');
        loading.value = false;
        return
    }

    // Save the current order to the session
    sessionStorage.setItem('order_id',data.data.order_id)

    window.location.assign(data.data.checkout_url);
}

const basketPrice = (s=null)=>{
    let lst = null

    if(!basket.value.items) return 0

    if(s){
        lst = basket.value.items.filter((el)=>{
            return el.model_id == s.id
        })
    }else{
        lst = basket.value.items
    }

    if(!lst || !lst.length) return 0

    let cnt = lst.reduce((a, b)=>{
        return a + b.price*b.qty;
    }, 0);

    return cnt
}

const pageBack = ()=>{
    step.value = 1
}

</script>

<template>
    <div class="rounded-xl shadow-md overflow-hidden mb-4 flex flex-col">
        <!-- <div class="p-4 flex flex-row items-center bg-facet-green text-light" v-if="voucher && voucher.show_id == show.id">
            <i class="icon icon-present text-xl text-light mr-4"></i>
            <p class="text-lg">
                Uw voucher is geactivieerd, u heeft {{ voucher.amount ?? 1 }} vrijkaart{{voucher.amount ?? 1 > 1 ? 'en':''}}!
            </p>
        </div> -->
        <div v-if="step==1">
            <div class="bg-light text-dark flex flex-col p-6 g-4 ls:px-44 xl:px-60">
                <div class="flex flex-col mb-4">
                    <h3 class="mb-2 border-b-[1px] border-slate-400 border-solid">Winkelmand</h3>
                    <div v-if="basket.items.length==0" class="text-lg font-semibold w-full text-center py-12 text-primary">Uw winkelmand is leeg, zoek snel een voorstelling uit!</div>
                    <div v-for="item in basket.items" class="flex flex-row justify-between my-2 gap-4" :key="item.id">
                        <img :src="item.img" class="h-36 rounded-md">
                        <div class="flex flex-col sm:flex-row sm:justify-between flex-grow">
                            <div class="flex flex-col mb-4 sm:mb-0">
                                <p class="text-lg font-bold">{{ item.name }}</p>
                                <small class="text-light-accent mb-2">{{ item.fields.start_time }}</small>
                                <small>
                                    <i class="icon icon-location-pin text-red-700"></i> {{ item.fields.location }}
                                </small>
                            </div>
                            <div class="flex flex-col items-end">
                                <p>Aantal: {{ item.qty }}</p>
                                <p class="font-semibold">€ {{ item.price*item.qty }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="basket.discount">
                        <p class="text-lg text-right border-t-[1px] border-solid border-slate-400">Subotaal: €{{ basket.subtotal }}</p>
                        <div class="flex flex-row justify-between my-4">
                            <p class="p-1 px-3 bg-facet-green rounded-md text-white"><i class="icon icon-present mr-1"></i> Voucher geactivieerd</p>
                            <p>Korting: 
                                <span class="bg-facet-green text-white rounded-md p-2 font-normal text-md">-€{{ basket.discount }}</span></p>
                        </div>
                    </div>
                    <p class="text-lg font-semibold text-right border-t-[1px] border-solid border-slate-400">Totaal: €{{ basket.total }}</p>
                </div>
                <form class="flex flex-col mb-4">
                    <h3 class="mb-2 border-b-[1px] border-slate-400 border-solid">Uw Gegevens</h3>
                    <div class="flex flex-col mb-2">
                        <label for="email" class="text-sm text-slate-400">Email</label>
                        <input type="email" name="email" id="email" placeholder="JullieGrootsteFan@email.com" class="rounded-md" v-model="customer.email" required :disabled="basket.voucher?.email" :class="{'text-gray-500':basket.voucher?.email}">
                        <small class="text-red-800">{{ errors && errors.email ? errors.email[0] : '' }}</small>
                    </div>
                    <div class="flex flex-row gap-2 mb-2">
                        <input type="checkbox" name="subscribe" id="subscribe" class="rounded-md" v-model="customer.subscribe" checked>
                        <label for="email" class="text-sm text-slate-400">Houd mij op de hoogte van nieuwe voorstellingen!</label>
                    </div>
                    <div class="flex flex-col mb-2">
                        <label for="first_name" class="text-sm text-slate-400">Voornaam</label>
                        <input type="text" name="first_name" id="first_name" placeholder="Voornaam"  class="rounded-md" v-model="customer.first_name" required>
                        <small class="text-red-800">{{ errors && errors.first_name ? errors.first_name[0] : '' }}</small>
                    </div>
                    <div class="flex flex-col mb-2">
                        <label for="infix" class="text-sm text-slate-400">Tussenvoegsel</label>
                        <input type="text" name="middle_name" id="infix" placeholder="Tussenvoegsel" class="rounded-md" v-model="customer.middle_name">
                        <small class="text-red-800">{{ errors && errors.middle_name ? errors.middle_name[0] : '' }}</small>
                    </div>
                    <div class="flex flex-col mb-2">
                        <label for="last_name" class="text-sm text-slate-400">Achternaam</label>
                        <input type="text" name="last_name" id="last_name" placeholder="Achternaam" class="rounded-md" v-model="customer.last_name" required>
                        <small class="text-red-800">{{ errors && errors.last_name ? errors.last_name[0] : '' }}</small>
                    </div>
                    <div class="flex flex-col mb-2">
                        <label for="phone" class="text-sm text-slate-400">Telefoon (optioneel)</label>
                        <input type="tel" name="phone" id="phone" placeholder="Telefoon" class="rounded-md" v-model="customer.phone">
                        <small class="text-red-800">{{ errors && errors.phone ? errors.phone[0] : '' }}</small>
                    </div>
                    <p class="text-slate-600 text-sm"><i class="icon icon-info"></i> Bij het drukken op deze knop gaat u akkoord met onze <a href="/algemene-voorwaarden" class="text-light-accent">algemene voorwaarden</a>.</p>                       
                </form>
            </div>
            <div class="flex flex-row justify-between sm:justify-end p-4 bg-light rounded-b-xl items-center">
                <a href="#" class="text-slate-500 uppercase px-8" @click.prevent="emit('back')" v-if="cancelPossible">Terug</a>
                <a href="#" type="submit" class="btn btn-primary relative" :class="{'disabled':basket.length==0}" @click.prevent="stepThree()">
                    <span :class="loading?'opacity-0':'opacity-100'">
                        Naar Betalen
                    </span>
                    <span class="absolute w-full h-full flex justify-center items-center top-0 left-0" v-show="loading">
                        <i class="icon icon-settings animate-spin text-inherit"></i>
                    </span>
                </a>
            </div>
        </div>
        <div v-else-if="step==2">
            <div class="bg-light text-dark flex flex-col p-6 g-4 ls:px-44 xl:px-60">
                <div class="flex flex-col mb-4">
                    <h3 class="mb-2 border-b-[1px] border-slate-400 border-solid">Winkelmand</h3>
                    <div v-if="basket.items.length==0" class="text-lg font-semibold w-full text-center py-12 text-primary">Uw winkelmand is leeg, snel een voorstelling uitzoeken!</div>
                    <div v-for="item in basket.items" class="flex flex-row justify-between my-2 gap-4" :key="item.id">
                        <img :src="item.img" class="h-36 rounded-md">
                        <div class="flex flex-col sm:flex-row sm:justify-between flex-grow">
                            <div class="flex flex-col mb-4 sm:mb-0">
                                <p class="text-lg font-bold">{{ item.name }}</p>
                                <small class="text-light-accent mb-2">{{ item.fields.start_time }}</small>
                                <small>
                                    <i class="icon icon-location-pin text-red-700"></i> {{ item.fields.location }}
                                </small>
                            </div>
                            <div class="flex flex-col items-end">
                                <p>Aantal: {{ item.qty }}</p>
                                <p class="font-semibold">€ {{ item.price*item.qty }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="basket.discount">
                        <p class="text-lg text-right border-t-[1px] border-solid border-slate-400">Subotaal: €{{ basket.subtotal }}</p>
                        <div class="flex flex-row justify-between my-4">
                            <p class="p-1 px-3 bg-facet-green rounded-md text-white"><i class="icon icon-present mr-1"></i> Voucher geactivieerd</p>
                            <p>Korting: 
                                <span class="bg-facet-green text-white rounded-md p-2 font-normal text-md">-€{{ basket.discount }}</span></p>
                        </div>
                    </div>
                    <p class="text-lg font-semibold text-right border-t-[1px] border-solid border-slate-400">Totaal: €{{ basket.total }}</p>
                </div>
                <div class="flex flex-col mb-4">
                    <h3 class="mb-2 border-b-[1px] border-slate-400 border-solid">Controleer Uw Gegevens</h3>
                    <table class="py-4">
                        <tr>
                            <td>Naam:</td>
                            <td>{{ customer.first_name }} {{ customer.middle_name }} {{ customer.last_name }}</td>
                        </tr>
                        <tr>
                            <td>Email:</td>
                            <td>{{ customer.email }}</td>
                        </tr>
                        <tr>
                            <td>Tel:</td>
                            <td>{{ customer.phone }}</td>
                        </tr>
                    </table>
                    <textarea name="extras" id="extras" cols="30" rows="4" v-model="extras" placeholder="Heeft u speciale wensen of opmerkingen?" class="rounded-md my-6">

                    </textarea>

                    <!-- <p class="text-slate-600 text-sm"><i class="icon icon-info"></i> Als u op de knop 'Betalen' drukt gaat u akkoord met onze <a href="/algemene-voorwaarden" class="text-light-accent">algemene voorwaarden</a>.</p>                        -->
                </div>
            </div>
            <div class="flex flex-row justify-between sm:justify-end p-4 bg-light rounded-b-xl items-center">
                <a href="#" class="text-slate-500 uppercase px-8" @click.prevent="pageBack()">Terug</a>
                <a href="#" type="submit" class="btn btn-primary relative" :class="{'disabled':basket.length==0}" @click.prevent="checkout()">
                    <span :class="loading?'opacity-0':'opacity-100'">
                        Betalen
                    </span>
                    <span class="absolute w-full h-full flex justify-center items-center top-0 left-0" v-show="loading">
                        <i class="icon icon-settings animate-spin text-inherit"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>
